export default "__VITE_ASSET__CWLyz00m__"